import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { QuotationReqModel } from '../../../../shared/classes/cotizar.model';
import { environment } from '../../../../../environments/environment';
import { NgxHttpClientExtraOptions } from 'ngx-httpclient';
import { QuotationReqModel } from '../../../models/cotizar.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CotizarService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
   }
  /**
   * @description recuperar cotizar
   * @params body
   */
  postQuotation(body: QuotationReqModel): Observable<object> {
    const httpOptions: NgxHttpClientExtraOptions = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
    };

    return this.http.post(
      environment.endpoints.urlBase +
      environment.endpoints.cotizar.name,
      body,
      httpOptions
    ).pipe(
      map((response: any) => {
        return {
          Precio_Total: response.precioTotal,
          Precio_Neto: response.precioNeto,
          Precio_IPS: response.precioIPS,
          Precio_Total_Fra: response.precioTotalFra,
          Precio_Neto_Fra: response.precioNetoFra,
          Porcentaje_IPS: response.porcentajeIPS,
          Precio_CCS: response.precioCCS,
          Porcentaje_CCS: response.porcentajeCCS,
          Precio_CCTES: response.precioCCTES
        };
      })
    );
  }
}
